import { configureStore } from '@reduxjs/toolkit'


import fileSlicer from './fileSlicer'
const store = configureStore({
  reducer: {
    getdata:fileSlicer
  },
})
export default store